import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.url.includes('http')) {
    return next(request);
  }
  const modifiedRequest = request.clone({ url: environment.api_url + request.url });

  return next(modifiedRequest);
};
